import { Web } from "./types";
import { SPRest } from "../rest";
export { Web, Webs, } from "./types";
Reflect.defineProperty(SPRest.prototype, "web", {
    configurable: true,
    enumerable: true,
    get: function () {
        return Web(this._baseUrl).configure(this._options);
    },
});
SPRest.prototype.createBatch = function () {
    return this.web.createBatch();
};
//# sourceMappingURL=index.js.map